// extracted by mini-css-extract-plugin
export default {"txt":"style_txt__V3Jc6","para":"style_para__wn1w7","paraselect":"style_paraselect__oPJ5K"};